import { FunctionComponent, useContext } from 'react';
import { Container } from '@mui/material';
import { ThemeContext } from '../providers/ThemeContext';
import useWindowDimensions from '../hooks/dimension';

interface BannerProps {

}

const Banner: FunctionComponent<BannerProps> = () => {

    const { height, width } = useWindowDimensions();
    const { darkMode } = useContext(ThemeContext)

    return (
        <div
            style={{
                height: (width && width < 800) ? 100 : 195,
            }}
        >
            <Container style={{
                paddingInline: (width && width < 800) ? 25 : 45,
                paddingBlock: 64,
            }}>
                <h1
                    style={{
                        fontWeight: 400,
                        fontSize: (width && width < 400) ? 24 : (width && width < 480) ? 28 : (width && width < 600) ? 32 : 36,
                        marginTop: -35,
                        color: darkMode ? 'white' : 'olive'
                    }}
                >GitHub Profile Generator</h1>
                <p
                    style={{
                        fontSize: (width && width < 400) ? 16 : (width && width < 480) ? 18 : (width && width < 600) ? 20 : 24,
                        fontWeight: 350,
                        marginTop: (width && width < 400) ? -10 : -20,
                        color: darkMode ? 'white' : 'olive'
                    }}
                >Generator for your awesome GitHub Profile</p>
            </Container>
        </div >
    );
}

export default Banner;